import { z } from 'zod';

/**
 * Selección de alcance que manda la SPA (header `X-Scope` o query `scope`):
 *  - `all`               → todas las empresas que el usuario puede ver
 *  - `client:<slug|id>`  → todas las empresas de un cliente ("Todas de Javier")
 *  - `tenant:<slug|id>`  → una empresa
 * La API SIEMPRE la intersecta con los permisos del usuario: nunca confía en lo que manda el browser.
 */
export const SCOPE_HEADER = 'x-scope';

export const scopeSelectionSchema = z
  .string()
  .regex(/^(all|(client|tenant):[a-z0-9][a-z0-9-]{0,62})$/, { error: 'Alcance inválido' });
export type ScopeSelection = z.infer<typeof scopeSelectionSchema>;

export type ParsedScope =
  { kind: 'all' } | { kind: 'client'; ref: string } | { kind: 'tenant'; ref: string };

/** `null` = selección mal formada. Vacío/ausente = `all`. */
export function parseScope(raw: string | undefined | null): ParsedScope | null {
  if (raw === undefined || raw === null || raw === '') return { kind: 'all' };
  const parsed = scopeSelectionSchema.safeParse(raw);
  if (!parsed.success) return null;
  const value = parsed.data;
  if (value === 'all') return { kind: 'all' };
  const idx = value.indexOf(':');
  const kind = value.slice(0, idx);
  const ref = value.slice(idx + 1);
  return kind === 'client' ? { kind: 'client', ref } : { kind: 'tenant', ref };
}

export function formatScope(scope: ParsedScope): string {
  return scope.kind === 'all' ? 'all' : `${scope.kind}:${scope.ref}`;
}
